export enum OrderDuration {
  CURRENT = "current",
  FUTURE = "future",
}
